import { api } from '@services';

const generateType = (actionType = 'CUSTOM', reducer = 'ORGANISM/CURRENCYCONVERTER') => `${reducer}/${actionType}`;

export const calcConverter = () => {
	return async (dispatch, getState) => {
		const { currency1, currency2, price } = getState().organism.currencyConverter;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.currencyConverter,
					data: {
						...getState().organism.currencyConverter.data,
						$result: res.info?.result,
						currency1,
						currency2,
						price,
					},
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CLEAR'),
				payload: { scope: 'data' },
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.currencyConverter,
					data: {
						...getState().organism.currencyConverter.data,
						_result: status,
					},
				},
			});
		};

		api.$product_calculator(
			{ onOK, onFail, onStatus },
			{ currency1: currency1.SYMBOL, currency2: currency2.SYMBOL, count: Number(price) },
		);
	};
};
